<template>
  <div class="d-inline-flex">
    <v-col class="pa-0">
      <h4 class="text-end">
        <span
          v-if="showRetailPrice"
          class="discount-price text-subtitle-2 text--secondary"
        >
          {{ formatter.format(totalRetailPrice) }}
        </span>
        {{ formatter.format(totalPrice) }}
        <span v-if="isProfUser" class="text-caption text--secondary">
          {{ $translate('EXCL_VAT') }}
        </span>
      </h4>
      <ProductQuantityButtons
        :quantity="quantity"
        :unit="unit"
        :isWeighted="isWeighted"
        :increaseBtnDisabled="increaseBtnDisabled"
        :decreaseBtnDisabled="decreaseBtnDisabled"
        @decrease="onDecreaseBtnClick"
        @increase="onIncreaseBtnClick"
      />
    </v-col>

    <v-row v-show="showDeleteBtn" class="ma-0 ml-3" align="end">
      <v-btn icon color="red accent-3" small @click="onRemoveBtnClick">
        <v-icon>delete</v-icon>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { isWeightedProduct } from '@/objects/Product';
import ProductQuantityButtons from '@/components/event/productDetails/ProductQuantityButtons';

export default {
  name: 'ShoppingListProductActions',
  components: {
    ProductQuantityButtons,
  },
  props: {
    product: Object,
    totalPrice: Number,
    quantity: Number,
    unit: String,
    isWeighted: Boolean,
    showDeleteBtn: {
      type: Boolean,
      default: true,
    },
    increaseBtnDisabled: Boolean,
    decreaseBtnDisabled: Boolean,
  },
  emits: ['decrease', 'increase', 'delete'],
  computed: {
    isProfUser() {
      return this.$store.getters.isProfUser;
    },
    showRetailPrice() {
      if (this.product == null) {
        return false;
      }

      let retailPriceValue = 0.0;
      let priceValue = 0.0;

      if (
        this.product.ItemRetailPrice != null &&
        this.product.ItemPrice != null
      ) {
        // Order already made
        retailPriceValue = Number(this.product.ItemRetailPrice);
        priceValue = Number(this.product.ItemPrice);
      } else if (
        this.product.RetailPrice != null &&
        this.product.Price != null
      ) {
        // Order not made yet, like 'Wishlist'
        retailPriceValue = Number(this.product.RetailPrice);
        priceValue = Number(this.product.Price);
      }

      let priceDiff = 0.0;
      if (!Number.isNaN(retailPriceValue) && !Number.isNaN(priceValue)) {
        priceDiff = retailPriceValue - priceValue;
      }

      return retailPriceValue > 0 && priceDiff > 0.01;
    },
    totalRetailPrice() {
      if (this.product.ItemRetailPrice != null) {
        let amount = this.product.Quantity;
        if (isWeightedProduct(this.product)) {
          amount = this.product.Quantity / this.product.StepSize;
        }

        if (this.isProfUser) {
          return (
            amount *
            (this.product.ItemRetailPrice - this.product.ItemRetailVatPrice)
          );
        }

        return amount * this.product.ItemRetailPrice;
      }

      if (this.isProfUser) {
        return this.product.RetailPriceExVat;
      }
      return this.product.RetailPrice;
    },
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  methods: {
    onDecreaseBtnClick() {
      this.$emit('decrease');
    },
    onIncreaseBtnClick() {
      this.$emit('increase');
    },
    onRemoveBtnClick() {
      this.$emit('delete');
    },
  },
};
</script>
